import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
export const SIGNUP_LINK_COLOR = '#0b8484';
export const StyledUILink = styled(UILink).withConfig({
  displayName: "TextInputstyles__StyledUILink",
  componentId: "ly2hgs-0"
})(["color:", ";"], SIGNUP_LINK_COLOR);